import React, { useEffect } from "react";
import * as S from "./styles";
import iconUser from "../../assets/user/account-circle.svg";
import Button from "../../components/Button";
import { mask } from "../../utils/mask";
import api from "../../services/api";
import { toast } from "react-toastify";
import { IoClose } from "react-icons/io5";

export default function PoPup({
  setOpenPopup,
  userSelected,
  updateList,
  setIsLoading,
  page,
  endPoint,
  regionalId,
  agenteId,
  convenioId,
  useMask,
  inativar,
  ativar,
  showCpfCnpj,
  textExclude,
  messageSuccess,
  messageFailed,
}) {
  useEffect(() => {
    setIsLoading(false);
  }, [userSelected]);

  const handleDeleteUser = async () => {
    try {
      const response = await api.delete(endPoint + userSelected?.id);
      if (response.status === 204 || response.status === 200) {
        toast.success(messageSuccess);
      }

      setOpenPopup(false);
      updateList(page);
    } catch (err) {
      setOpenPopup(false);
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error(messageFailed` ${mask(userSelected?.cpf, useMask, true)}`);
      }
    }
  };

  const handleActivateUser = async () => {
    const dataSending = {
      id: userSelected?.id,
      status: true,
    };

    try {
      const response = await api.put(
        endPoint + "update-status/" + dataSending?.id,
        dataSending
      );
      if (response.status === 204 || response.status === 200) {
        toast.success(messageSuccess);
      }

      setOpenPopup(false);
      updateList(page);
    } catch (err) {
      setOpenPopup(false);
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error(messageFailed` ${mask(userSelected?.cpf, useMask, true)}`);
      }
    }
    setOpenPopup(false);
  };

  return (
    <>
      <S.PopupBackground>
        <S.PopupContainer>
          <S.TitleCloseBtn>
            <button
              onClick={() => {
                setOpenPopup(false);
              }}
            >
              <IoClose />
            </button>
          </S.TitleCloseBtn>
          <S.UserTitle>
            <img src={iconUser} alt="" />
          </S.UserTitle>

          <S.BodyTitle>
            <p>{textExclude}</p>
          </S.BodyTitle>

          {showCpfCnpj ? (
            <S.BodyUser>
              <label>
                {!!userSelected && mask(userSelected?.cpf, useMask, true)}
              </label>
            </S.BodyUser>
          ) : (
            <S.BodyUser />
          )}

          <S.FooterUser>
            {inativar === false && ativar === true ? (
              <Button onClick={() => handleActivateUser()}>Sim! Ativar</Button>
            ) : (
              <Button onClick={() => handleDeleteUser()}>
                Sim! {inativar ? "Inativar" : "Excluir"}
              </Button>
            )}
          </S.FooterUser>
        </S.PopupContainer>
      </S.PopupBackground>
    </>
  );
}
